import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const blogsApi = createApi({
  reducerPath: "blogsApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["blogs"],
  endpoints: (builder) => ({
    findBlogBySearch: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.BlogController.findBlogBySearch,
          method: "POST",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),

    findBlogDetailById: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.BlogController.findBlogDetailById}/${body.id}`,
          method: "GET",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
  }),
});

export const { useFindBlogBySearchMutation, useFindBlogDetailByIdMutation } =
  blogsApi;
